import axios from "axios";
import React, { useContext, useState } from "react";
import { Col, Container } from "react-bootstrap";
import Fade from "react-reveal/Fade";
import Button from "../../components/ButtonComponent";
import { Section, Title } from "../../components/Common/PageElement";
import UploaderComponent, {
    UploadPreview,
} from "../../components/UploadComponent";
import { LoadContext } from "../../context/LoadContext";
import { SERVER_URL,META_API, UPLOAD_TRACKS } from "../../services/Config";
import { TokenService } from "../../services/Token";
import { PreviewTitle, UploadRow } from "./StyleUpload";

import {SERVER_PREFIX} from "../../services/Config";
import {ANNOTREE_DATABASE, UPLOAD_SORT} from "../../services/Constant";
import {DropdownMenu} from "../../components/Form";

const Upload = () => {
    const { setLoad } = useContext(LoadContext);

    // File States
    const [dataFiles, setDataFiles] = useState([]);
    const [metaFiles, setMetaFiles] = useState([]);

    // const [fileType, setFileType] = useState([]);


    const [sortTracks, setSortTracks] = useState(2);


    const faqAddress = `${SERVER_PREFIX}/FAQ#Upload0`
    const contactAddress = `${SERVER_PREFIX}/FAQ#General1`

    // Handle Files
    const dataFileCallback = (file) => {
        setDataFiles((prevFiles) => [...prevFiles, file]);
    };

    const metaFileCallback = (file) => {
        setMetaFiles((prevFiles) => [...prevFiles, file]);
    };
    //
    // const faqAddress = `${SERVER_PREFIX}/FAQ#Upload0`
    // const contactAddress = `${SERVER_PREFIX}/FAQ#General1`

    // const csvFileCallback = (file) => {
    //     setCsvFiles((prevFiles) => [...prevFiles, file]);
    // };

    // const fileSize = (size) => {
    //     if (size === 0) return '0 Bytes';
    //     const k = 1024;
    //     const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    //     const i = Math.floor(Math.log(size) / Math.log(k));
    //     return parseFloat((size / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    // }

    const dataRemoveFileCallback = (fileName) => {
        const dataFileIndex = dataFiles.findIndex((e) => e.name === fileName);
        dataFiles.splice(dataFileIndex, 1);
        setDataFiles([...dataFiles]);
    };

    const metaRemoveFileCallback = (fileName) => {
        const metaFileIndex = metaFiles.findIndex((e) => e.name === fileName);
        metaFiles.splice(metaFileIndex, 1);
        setMetaFiles([...metaFiles]);
    };
    // Upload
    const uploadFiles = () => {
        let curLimitFileSize = 1
        // let curLimitFileSize = 1

        if(dataFiles.length === 0){
            alert('please select files')
            return
        }

        let flag = 0
        let totalSize = 0
        dataFiles.forEach((file)=>{
            totalSize += file.size


            // 5242880 is 5 MB
            // console.log(file.size)8388608 = 8mb
            // 15mb = 15728640
            // if(curLimitFileSize === 1 && file.size > 5242880){
            // if(curLimitFileSize === 1 && file.size > 8388608){
            if(curLimitFileSize === 1 && file.size > 15728640*2){

                alert("Sorry, the maximum file size for an individual file is limited to 5 MB.")
                flag = 1

            }
        })

        if(flag === 1){
            return
        }

        console.log(totalSize)
        // total size is larger than 16 MB
        if(curLimitFileSize === 1 && totalSize >= 15728640*2){
            alert("Sorry, the maximum total file size is limited to 16 MB.")
            return
        }

        // upload is so fast, so maybe skip progress and token check?
        setLoad({'value':3,'token':''});

        // if(dataFiles.length === 0){
        //     setLoad(0);
        //     alert("Please select uploaded files");
        //     return
        // }

        const token = TokenService(40);

        // const formMetaData = new FormData();
        // const formTrackData = new FormData();
        //
        // formTrackData.append("token", token);
        // formMetaData.append("token", token);
        //
        // metaFiles.forEach((file) => {
        //     formMetaData.append("metas", file);
        // });
        //
        // dataFiles.forEach((file) => {
        //     formTrackData.append("tracks", file);
        // });

        //
        // if(dataFiles.length === 0 && csvFiles.length > 0){
        //     csvFiles.forEach((file) => {
        //         formTrackData.append("csvFile", file);
        //     });
        // }


        // upload both track and metadata:
        const uploadData = new FormData();
        uploadData.append("token", token);
        metaFiles.forEach((file) => {
            uploadData.append("metas", file);
        });

        dataFiles.forEach((file) => {
            uploadData.append("tracks", file);
        });

        // this only used for DUF4123 test

        //0 means auto flip, 1 means auto sort, 2 means no algorithm applied

        uploadData.append("sortTracks", sortTracks.toString());
        // let sortTracks = 0
        // if(sortTracks === 1){
        //     uploadData.append("sortTracks", 1);
        // }
        // else{
        //     uploadData.append("sortTracks", 0);
        // }



        axios
            .all([
                // axios.post(SERVER_URL + UPLOAD_TRACKS, formTrackData),
                axios.post(SERVER_URL + UPLOAD_TRACKS, uploadData),
                // metaFiles.length === 0
                //     ? ""
                //     : axios.post(SERVER_URL + META_API, formMetaData),
            ])
            .then((response) => {

                // response if list of string, due to axios.all
                console.log(response)
                // response 400 means the error is on mongod and possibly the size of all files is larger than 16MB
                if(response[0].data === '400'){
                    setLoad(0);
                    alert("The total size of all files should not be larger than 16MB.");
                }
                else{
                    console.log(`${SERVER_PREFIX}/app/#/?id=`)
                    window.location.href = `${SERVER_PREFIX}/app/#/?id=` + token;
                }



            })
            .catch(() => {
                setLoad(0);
                alert("ERROR");
            });
    };

    return (
        <Section id="upload">
            <Container>
                <Fade top duration={1000} delay={600} distance="15px">
                    <Title align="center">Upload</Title>
                </Fade>
                <Fade duration={1000} delay={600} distance="30px">
                    <UploadRow>
                        <Col>
                            <UploaderComponent
                                title="Upload Genomic Data"
                                tooltip="Uploaded files must be in .gbk, .gff, or .csv format."
                                fileCallback={dataFileCallback}
                            />
                        </Col>
                        {/*<Col>*/}
                        {/*    <UploaderComponent*/}
                        {/*        title="Upload Metadata (optional)"*/}
                        {/*        tooltip="Ensure that the first column is your matching identifier (Protein ID, Gene, Product, or ID) and your second column is your meta data (data you wish to match with each gene)."*/}
                        {/*        fileCallback={metaFileCallback}*/}
                        {/*    />*/}
                        {/*</Col>*/}



                        {/*<Col>*/}
                        {/*    <UploaderComponent*/}
                        {/*        title="Upload csv file"*/}
                        {/*        tooltip="The uploaded file must follow the format of csv files generated by Annoview"*/}
                        {/*        fileCallback={csvFileCallback}*/}
                        {/*    />*/}
                        {/*</Col>*/}
                    </UploadRow>
                    <UploadRow>
                        {/*<Col md={{ span: 4, offset: 1 }}>*/}
                        <Col>
                            <DropdownMenu
                                options={UPLOAD_SORT}
                                val="id"
                                label="name"
                                formlabel="Genome Sort"
                                onChange={(event) =>
                                    setSortTracks(event.target.value)
                                }
                                value={sortTracks}
                            />
                        </Col>

                    </UploadRow>
                    <UploadRow>

                        <Col md={{ span: 6, offset: 3 }}>
                            <Button
                                fill
                                disabled={dataFiles.length === 0 ? true : false}
                                onClick={() => uploadFiles()}
                            >
                                Upload
                            </Button>
                        </Col>
                    </UploadRow>
                    <UploadRow>
                        {dataFiles.length !== 0 ? (
                            <Col md={6}>
                                <PreviewTitle>
                                    Genomic Data Files ({dataFiles.length}{" "}
                                    files)
                                </PreviewTitle>
                                <UploadPreview
                                    files={dataFiles}
                                    removeFileCallback={dataRemoveFileCallback}
                                />
                            </Col>
                        ) : (
                            ``
                        )}
                        {metaFiles.length !== 0 ? (
                            <Col md={{ span: 6, offset: 6 }}>
                                <PreviewTitle>
                                    Meta Data Files ({metaFiles.length} files)
                                </PreviewTitle>
                                <UploadPreview
                                    files={metaFiles}
                                    removeFileCallback={metaRemoveFileCallback}
                                />
                            </Col>
                        ) : (
                            ``
                        )}
                    </UploadRow>
                    <UploadRow>
                        <a style={{ paddingLeft: '20px' ,fontSize:'12px'}}>
                            Have questions about the file format?
                            Please see our &nbsp;
                            <a href={faqAddress} style={{ color: 'blue', textDecoration: 'underline' }}>FAQ page</a>
                            &nbsp;
                            or
                            &nbsp;
                            <a href={contactAddress} style={{ color: 'blue', textDecoration: 'underline' }}>contact us!</a>
                        </a>
                    </UploadRow>
                </Fade>
            </Container>
        </Section>
    );
};

export default Upload;
